var pageSectionList = $(".page-section-list");

function syncActiveLine(){
	var array = [];
	$(".section .anchor").each(function(){
		if(scrollTop >= Math.floor($(this).offset().top)){
			array.push($(this).attr('id'));
		}
	})
	
	$("[data-to-section='" + array[array.length - 1] + "']").parent().addClass('active').siblings().removeClass('active');
	var offsetTop = pageSectionList.offset().top;
	$(".border-placer .topline").css('top', $("li.active", pageSectionList).offset().top - offsetTop);
	$(".border-placer .btmline").css('top', $("li.active", pageSectionList).offset().top + $("li.active", pageSectionList).outerHeight() - offsetTop);
}

if(pageSectionList.length){
	syncActiveLine();
	$(window).on('resize', syncActiveLine);
	$(window).on('scroll', syncActiveLine);
}

function syncActiveSubCat(){
	$(".sub-cat-ul").each(function(){
		var activeElem = $("li.active", this);
		var offsetLeft = $(".sub-cat-ul .overflow-container").offset().left;
		var scrollOffset = $(".sub-cat-ul .overflow-container").scrollLeft();
		$(".track", this)
		.css('left', activeElem.offset().left - offsetLeft + scrollOffset)
		.width(activeElem.outerWidth());
	})
}

if($(".sub-cat-ul").length){
	syncActiveSubCat();
	$(window).on('resize', syncActiveSubCat);

	var scrollElem = $(".sub-cat-ul .overflow-container");
	scrollElem.on('scroll', function(){
		if((scrollElem.scrollLeft() + scrollElem.width() + 4) >= Math.floor($("ul", scrollElem).width())){
			$("[data-scroll-right]").fadeOut();
		}else{
			$("[data-scroll-right]").fadeIn();
		}
		if(scrollElem.scrollLeft() == 0){
			$("[data-scroll-left]").fadeOut();
		}else{
			$("[data-scroll-left]").fadeIn();
		}
	}).trigger("scroll");

	$("[data-scroll-left]").click(function(e){
		e.preventDefault();
		scrollElem.scrollTo("-=250px", {axis:"x"});
	})
	$("[data-scroll-right]").click(function(e){
		e.preventDefault();
		scrollElem.scrollTo("+=250px", {axis:"x"});
	})
}

$("[data-to-section]").click(function(e){
    var elem = $(this).data("to-section");
    if($("#" + elem).length) $.scrollTo($("#" + elem), {
    	duration: 1500,
    	onAfter: syncActiveLine()
    });
})

// $("a", pageSectionList).click(function(e){
// 	$(this).parent().addClass("active").siblings().removeClass("active");
// 	// syncActiveLine();
// })

$(".sub-cat-ul a").click(function(e){
	e.preventDefault();
	$(this).parent().addClass("active").siblings().removeClass("active");
	syncActiveSubCat();
})

$("[data-biggift-slide]").click(function(e){
	// bigGiftSwiper.slideTo($(this).data("biggift-slide"));
	var active = $(".slides." + $(this).data("biggift-slide"));

	var swiper = $(".main-swiper", active).get(0).swiper;
	if(swiper){
		swiper.slideTo(0);
    	swiper.autoplay.start();
	}
    
	if(active.is(':visible')) return false;
	active.siblings().hide();
	active.css('opacity', 0).show().transition({
        opacity: 1
    }, 1000);

	
})

function packageSwiperInit(){
	$(".sub-cat-content .slides").each(function(){
		var isVisible = $(this).is(":visible");
		$(this).show();
		if($(".swiper-slide", this).length){
			if(viewport().width >= 992){
				var packageMainSwiper = new Swiper($('.main-swiper', this), {
					spaceBetween: 20,
					slidesPerView: 'auto',
					speed: 1000,
					autoplay: {
						delay: 3000,
					},
				});
				packageMainSwiper.autoplay.stop();
			}else{
				var packageMainSwiper = new Swiper($('.main-swiper', this), {
					spaceBetween: 20,
					slidesPerView: 'auto',
					speed: 1000,
					autoplay: {
						delay: 3000,
					},
				});
				packageMainSwiper.autoplay.stop();
			}
		}
		if(!isVisible) $(this).hide();
	})
	$("[data-biggift-slide]").parent(".active").children().trigger("click");
}

packageSwiperInit();

$(".sub-cat-content .slides").not(":first-child").hide();

function packageSwiperDestroy(){
	$(".sub-cat-content .slides").each(function(){
		var swiper = $('.thumb-swiper', this).get(0).swiper;
		swiper.destroy(true, true);
		var swiper = $('.main-swiper', this).get(0).swiper;
		swiper.destroy(true, true);
	})
}

var tl = gsap.timeline();
tl.from(".style-1 .image-holder", {duration:2, delay:1, opacity:0, y:120});
tl.from(".style-1 .text-holder", {duration:1.5, opacity:0, y:"10%"}, "-=1");
tl.pause();

$(window).on('load', function(){
	// gsap.set(".style-1 .image-holder", {opacity: 0, y:120});
	// gsap.set(".style-1 .text-holder", {opacity: 0, y:"10%"});
	tl.play();
})

var viewportEffect = viewport().width >= 992 ? 'desktop' : 'mobile';
var scrollMagicController;
var scrollScene = [];
var scrollSceneElem = [];

function desktopScrollMagic(){
	scrollMagicController = new ScrollMagic.Controller();

	var tween = new TimelineMax ()
	.add([
		TweenMax.fromTo(".style-1 .image-holder", {y:0}, {y:200, duration:1, ease: Linear.easeNone}),
		// TweenMax.to(".style-1 .image-holder", 1, {opacity:"0", ease: Linear.easeNone}, 0.5),
		TweenMax.fromTo(".style-1 .text-holder", {y:0}, {y: 100, duration:1, ease: Linear.easeNone}),
	])

	var scene = new ScrollMagic.Scene({
		triggerElement: "section.chinese-wedding-style",
		triggerHook: 0,
		duration: "85%",
	})
	.setTween(tween)
	// .addIndicators()
	.addTo(scrollMagicController);
	scrollScene.push(scene);
	scrollSceneElem.push('.style-1 .image-holder', '.style-1 .text-holder');

	var tween = new TimelineMax ()
	.add([
		TweenMax.fromTo(".style-2 .image-holder", {opacity: 0}, {opacity:1, ease: Linear.easeNone}),
	])

	var scene = new ScrollMagic.Scene({
		triggerElement: ".style-2",
		triggerHook: 1,
		duration: "70%",
	})
	.setTween(tween) // trigger a TweenMax.to tween
	// .addIndicators()
	.addTo(scrollMagicController);
	scrollScene.push(scene);
	scrollSceneElem.push('.style-2 .image-holder');

	var tween = new TimelineMax ()
	.add([
		TweenMax.fromTo(".style-2 .text-holder .section-title", {opacity:0, y:50}, {opacity:1, y:0, ease: Linear.easeNone}),
		
	])
	.add([
		TweenMax.fromTo(".style-2 .text-holder .row", {opacity:0, y:50}, {opacity:1, y:0, ease: Linear.easeNone}),
	], "-=0.4");

	var scene = new ScrollMagic.Scene({
		triggerElement: ".style-2 .text-holder",
		triggerHook: 1,
		duration: "50%",
	})
	.setTween(tween) // trigger a TweenMax.to tween
	// .addIndicators()
	.addTo(scrollMagicController);
	scrollScene.push(scene);
	scrollSceneElem.push('.style-2 .text-holder .section-title', '.style-2 .text-holder .row');

	var tween = new TimelineMax ()
	.add([
		TweenMax.fromTo(".style-3 .image-holder", {opacity: 0}, {opacity:1, ease: Linear.easeNone}),
	])

	var scene = new ScrollMagic.Scene({
		triggerElement: ".style-3",
		triggerHook: 1,
		duration: "50%",
	})
	.setTween(tween) // trigger a TweenMax.to tween
	// .addIndicators()
	.addTo(scrollMagicController);
	scrollScene.push(scene);
	scrollSceneElem.push('.style-3 .image-holder');

	var tween = new TimelineMax ()
	.add([
		TweenMax.fromTo(".style-3 .text-holder .section-title", {opacity:0, y:50}, {opacity:1, y:0, ease: Linear.easeNone}),
	])
	.add([
		TweenMax.fromTo(".style-3 .text-holder .row", {opacity:0, y:50}, {opacity:1, y:0, ease: Linear.easeNone}),
	], "-=0.4");

	var scene = new ScrollMagic.Scene({
		triggerElement: ".style-3 .text-holder",
		triggerHook: 1,
		duration: "50%",
	})
	.setTween(tween) // trigger a TweenMax.to tween
	// .addIndicators()
	.addTo(scrollMagicController);
	scrollScene.push(scene);
	scrollSceneElem.push('.style-3 .text-holder .section-title', '.style-3 .text-holder .row');

	var tween = new TimelineMax ()
	.add([
		TweenMax.fromTo(".style-4 .image-holder", {opacity: 0}, {opacity:1, ease: Linear.easeNone}),
	])

	var scene = new ScrollMagic.Scene({
		triggerElement: ".style-4",
		triggerHook: 1,
		duration: "70%",
	})
	.setTween(tween) // trigger a TweenMax.to tween
	// .addIndicators()
	.addTo(scrollMagicController);
	scrollScene.push(scene);
	scrollSceneElem.push('.style-4 .image-holder');

	var tween = new TimelineMax ()
	.add([
		TweenMax.fromTo(".style-4 .text-holder .section-title", {opacity:0, y:50}, {opacity:1, y:0, ease: Linear.easeNone}),
	])
	.add([
		TweenMax.fromTo(".style-4 .text-holder .cms-content", {opacity:0, y:50}, {opacity:1, y:0, ease: Linear.easeNone}),
	], "-=0.4");

	var scene = new ScrollMagic.Scene({
		triggerElement: ".style-4 .text-holder",
		triggerHook: 1,
		duration: "50%",
	})
	.setTween(tween) // trigger a TweenMax.to tween
	// .addIndicators()
	.addTo(scrollMagicController);
	scrollScene.push(scene);
	scrollSceneElem.push('.style-4 .text-holder .section-title', '.style-4 .text-holder .cms-content');

	var tween = new TimelineMax ()
	.add([
		TweenMax.fromTo(".style-4 .sub-cat-ul", {opacity:0, y:100}, {opacity:1, y:0, ease: Linear.easeNone}),
	])
	.add([
		TweenMax.fromTo(".style-4 .sub-cat-content", {opacity:0, y:100}, {opacity:1, y:0, ease: Linear.easeNone}),
	], "-=0.4");

	var scene = new ScrollMagic.Scene({
		triggerElement: ".style-4 .sub-cat-ul",
		triggerHook: .8,
		duration: "50%",
	})
	.setTween(tween) // trigger a TweenMax.to tween
	// .addIndicators()
	.addTo(scrollMagicController);
	scrollScene.push(scene);
	scrollSceneElem.push('.style-4 .sub-cat-ul', '.style-4 .sub-cat-content');

	var tween = new TimelineMax ()
	.add([
		// TweenMax.to(".style-1 .image-holder", 1, {opacity:"0", ease: Linear.easeNone}, 0.5),
		TweenMax.fromTo(".style-5 .image-field", {opacity:0, y:20}, {opacity:1, y:0, ease: Linear.easeNone}),
	])
	.add([
		TweenMax.fromTo(".style-5 .text-field", {opacity:0, x:40}, {opacity:1, x:0, ease: Linear.easeNone}),
	], "-=0.5")

	var scene = new ScrollMagic.Scene({
		triggerElement: ".style-5 .photo-frame",
		triggerHook: .8,
		duration: "60%",
	})
	.setTween(tween) // trigger a TweenMax.to tween
	// .addIndicators()
	.addTo(scrollMagicController);
	scrollScene.push(scene);
	scrollSceneElem.push('.style-5 .image-field', '.style-5 .text-field');

	var tween = new TimelineMax ()
	.add([
		// TweenMax.to(".style-1 .image-holder", 1, {opacity:"0", ease: Linear.easeNone}, 0.5),
		TweenMax.fromTo(".style-6 .image-field", {opacity:0, y:20}, {opacity:1, y:0, ease: Linear.easeNone}),
	])
	.add([
		TweenMax.fromTo(".style-6 .text-field", {opacity:0, x:40}, {opacity:1, x:0, ease: Linear.easeNone}),
	], "-=0.5")

	var scene = new ScrollMagic.Scene({
		triggerElement: ".style-6 .photo-frame",
		triggerHook: .8,
		duration: "60%",
	})
	.setTween(tween) // trigger a TweenMax.to tween
	// .addIndicators()
	.addTo(scrollMagicController);
	scrollScene.push(scene);
	scrollSceneElem.push('.style-6 .image-field', '.style-6 .text-field');

	var tween = new TimelineMax ()
	.add([
		// TweenMax.to(".style-1 .image-holder", 1, {opacity:"0", ease: Linear.easeNone}, 0.5),
		TweenMax.fromTo(".style-7 .image-field", {opacity:0, y:20}, {opacity:1, y:0, ease: Linear.easeNone}),
	])
	.add([
		TweenMax.fromTo(".style-7 .text-field", {opacity:0, x:40}, {opacity:1, x:0, ease: Linear.easeNone}),
	], "-=0.5")

	var scene = new ScrollMagic.Scene({
		triggerElement: ".style-7 .photo-frame",
		triggerHook: .8,
		duration: "60%",
	})
	.setTween(tween) // trigger a TweenMax.to tween
	// .addIndicators()
	.addTo(scrollMagicController);
	scrollScene.push(scene);
	scrollSceneElem.push('.style-7 .image-field', '.style-7 .text-field');
}

function mobileScrollMagic(){
	scrollMagicController = new ScrollMagic.Controller();

	var tween = new TimelineMax ()
	.add([
		TweenMax.fromTo(".style-1 .image-holder", {y:0}, {y: 50, duration:1, ease: Linear.easeNone}),
		// TweenMax.to(".style-1 .image-holder", 1, {opacity:"0", ease: Linear.easeNone}, 0.5),
		TweenMax.fromTo(".style-1 .text-holder", {y:0}, {y: 60, duration:1, ease: Linear.easeNone}),
	])

	var scene = new ScrollMagic.Scene({
		triggerElement: "section.chinese-wedding-style",
		triggerHook: 0,
		duration: "100%",
	})
	.setTween(tween)
	// .addIndicators()
	.addTo(scrollMagicController);
	scrollScene.push(scene);
	scrollSceneElem.push('.style-1 .image-holder', '.style-1 .text-holder');

	var tween = new TimelineMax ()
	.add([
		TweenMax.fromTo(".style-2 .image-holder", {opacity: 0}, {opacity:1, ease: Linear.easeNone}),
	])

	var scene = new ScrollMagic.Scene({
		triggerElement: ".style-2",
		triggerHook: 1,
		duration: "70%",
	})
	.setTween(tween) // trigger a TweenMax.to tween
	// .addIndicators()
	.addTo(scrollMagicController);
	scrollScene.push(scene);
	scrollSceneElem.push('.style-2 .image-holder');

	var tween = new TimelineMax ()
	.add([
		TweenMax.fromTo(".style-2 .text-holder .section-title", {opacity:0, y:50}, {opacity:1, y:0, ease: Linear.easeNone}),
		
	])
	.add([
		TweenMax.fromTo(".style-2 .text-holder .row", {opacity:0, y:50}, {opacity:1, y:0, ease: Linear.easeNone}),
	], "-=0.4");

	var scene = new ScrollMagic.Scene({
		triggerElement: ".style-2 .text-holder",
		triggerHook: 1,
		duration: "50%",
	})
	.setTween(tween) // trigger a TweenMax.to tween
	// .addIndicators()
	.addTo(scrollMagicController);
	scrollScene.push(scene);
	scrollSceneElem.push('.style-2 .text-holder .section-title', '.style-2 .text-holder .row');

	var tween = new TimelineMax ()
	.add([
		TweenMax.fromTo(".style-3 .image-holder", {opacity: 0}, {opacity:1, ease: Linear.easeNone}),
	])

	var scene = new ScrollMagic.Scene({
		triggerElement: ".style-3",
		triggerHook: 1,
		duration: "50%",
	})
	.setTween(tween) // trigger a TweenMax.to tween
	// .addIndicators()
	.addTo(scrollMagicController);
	scrollScene.push(scene);
	scrollSceneElem.push('.style-3 .image-holder');

	var tween = new TimelineMax ()
	.add([
		TweenMax.fromTo(".style-3 .text-holder .section-title", {opacity:0, y:50}, {opacity:1, y:0, ease: Linear.easeNone}),
	])
	.add([
		TweenMax.fromTo(".style-3 .text-holder .row", {opacity:0, y:50}, {opacity:1, y:0, ease: Linear.easeNone}),
	], "-=0.4");

	var scene = new ScrollMagic.Scene({
		triggerElement: ".style-3 .text-holder",
		triggerHook: 1,
		duration: "50%",
	})
	.setTween(tween) // trigger a TweenMax.to tween
	// .addIndicators()
	.addTo(scrollMagicController);
	scrollScene.push(scene);
	scrollSceneElem.push('.style-3 .text-holder .section-title', '.style-3 .text-holder .row');

	var tween = new TimelineMax ()
	.add([
		TweenMax.fromTo(".style-4 .image-holder", {opacity: 0}, {opacity:1, ease: Linear.easeNone}),
	])

	var scene = new ScrollMagic.Scene({
		triggerElement: ".style-4",
		triggerHook: 1,
		duration: "70%",
	})
	.setTween(tween) // trigger a TweenMax.to tween
	// .addIndicators()
	.addTo(scrollMagicController);
	scrollScene.push(scene);
	scrollSceneElem.push('.style-4 .image-holder');

	var tween = new TimelineMax ()
	.add([
		TweenMax.fromTo(".style-4 .text-holder .section-title", {opacity:0, y:50}, {opacity:1, y:0, ease: Linear.easeNone}),
	])
	.add([
		TweenMax.fromTo(".style-4 .text-holder .cms-content", {opacity:0, y:50}, {opacity:1, y:0, ease: Linear.easeNone}),
	], "-=0.4");

	var scene = new ScrollMagic.Scene({
		triggerElement: ".style-4 .text-holder",
		triggerHook: 1,
		duration: "50%",
	})
	.setTween(tween) // trigger a TweenMax.to tween
	// .addIndicators()
	.addTo(scrollMagicController);
	scrollScene.push(scene);
	scrollSceneElem.push('.style-4 .text-holder .section-title', '.style-4 .text-holder .cms-content');

	var tween = new TimelineMax ()
	.add([
		TweenMax.fromTo(".style-4 .sub-cat-ul", {opacity:0, y:100}, {opacity:1, y:0, ease: Linear.easeNone}),
	])
	.add([
		TweenMax.fromTo(".style-4 .sub-cat-content", {opacity:0, y:100}, {opacity:1, y:0, ease: Linear.easeNone}),
	], "-=0.4");

	var scene = new ScrollMagic.Scene({
		triggerElement: ".style-4 .sub-cat-ul",
		triggerHook: .8,
		duration: "50%",
	})
	.setTween(tween) // trigger a TweenMax.to tween
	// .addIndicators()
	.addTo(scrollMagicController);
	scrollScene.push(scene);
	scrollSceneElem.push('.style-4 .sub-cat-ul', '.style-4 .sub-cat-content');

	var tween = new TimelineMax ()
	.add([
		// TweenMax.to(".style-1 .image-holder", 1, {opacity:"0", ease: Linear.easeNone}, 0.5),
		TweenMax.fromTo(".style-5 .image-field", {opacity:0, y:20}, {opacity:1, y:0, ease: Linear.easeNone}),
	])
	.add([
		TweenMax.fromTo(".style-5 .text-field", {opacity:0, x:40}, {opacity:1, x:0, ease: Linear.easeNone}),
	], "-=0.5")

	var scene = new ScrollMagic.Scene({
		triggerElement: ".style-5 .photo-frame",
		triggerHook: .8,
		duration: "60%",
	})
	.setTween(tween) // trigger a TweenMax.to tween
	// .addIndicators()
	.addTo(scrollMagicController);
	scrollScene.push(scene);
	scrollSceneElem.push('.style-5 .image-field', '.style-5 .text-field');

	var tween = new TimelineMax ()
	.add([
		// TweenMax.to(".style-1 .image-holder", 1, {opacity:"0", ease: Linear.easeNone}, 0.5),
		TweenMax.fromTo(".style-6 .image-field", {opacity:0, y:20}, {opacity:1, y:0, ease: Linear.easeNone}),
	])
	.add([
		TweenMax.fromTo(".style-6 .text-field", {opacity:0, x:40}, {opacity:1, x:0, ease: Linear.easeNone}),
	], "-=0.5")

	var scene = new ScrollMagic.Scene({
		triggerElement: ".style-6 .photo-frame",
		triggerHook: .8,
		duration: "60%",
	})
	.setTween(tween) // trigger a TweenMax.to tween
	// .addIndicators()
	.addTo(scrollMagicController);
	scrollScene.push(scene);
	scrollSceneElem.push('.style-6 .image-field', '.style-6 .text-field');

	var tween = new TimelineMax ()
	.add([
		// TweenMax.to(".style-1 .image-holder", 1, {opacity:"0", ease: Linear.easeNone}, 0.5),
		TweenMax.fromTo(".style-7 .image-field", {opacity:0, y:20}, {opacity:1, y:0, ease: Linear.easeNone}),
	])
	.add([
		TweenMax.fromTo(".style-7 .text-field", {opacity:0, x:40}, {opacity:1, x:0, ease: Linear.easeNone}),
	], "-=0.5")

	var scene = new ScrollMagic.Scene({
		triggerElement: ".style-7 .photo-frame",
		triggerHook: .8,
		duration: "60%",
	})
	.setTween(tween) // trigger a TweenMax.to tween
	// .addIndicators()
	.addTo(scrollMagicController);
	scrollScene.push(scene);
	scrollSceneElem.push('.style-7 .image-field', '.style-7 .text-field');
}

if(viewportEffect == 'desktop'){
	desktopScrollMagic();
}else{
	mobileScrollMagic();
}

$(window).on('resize', function(){
	if(viewportEffect != (viewport().width >= 992 ? 'desktop' : 'mobile')){
		viewportEffect = (viewport().width >= 992 ? 'desktop' : 'mobile');
		if(scrollMagicController){
			scrollMagicController.destroy(true);
			scrollMagicController = null;
			if(scrollScene) scrollScene.forEach(item => item.destroy(true));
			scrollScene = [];
			if(scrollSceneElem) scrollSceneElem.forEach(item => $(item).removeAttr('style'));
			scrollSceneElem = [];
		}
		if(viewportEffect == 'desktop'){
			desktopScrollMagic();
		}else{
			mobileScrollMagic();
		}
		packageSwiperDestroy();
		packageSwiperInit();
	}
})










